module.exports = {
    "collapse": `Sa\u{17E}mi`,
    "expand": `Pro\u{161}iri`
};


//# sourceMappingURL=hr-HR.main.js.map
